import React from 'react';

const divStyle = {
    padding: '120px',
    textAlign: 'center',
    fontSize:'30px'
};

const LoadingSpinner = () => (

        <div style={divStyle}>
            <i className="fa fa-spinner fa-spin" /> Loading...
        </div>

);


export default LoadingSpinner;


/** WEBPACK FOOTER **
 ** ./src/feature/loadingSpinner.js
 **/